<lib-modal-layout [title]="title" [subtitle]="subtitle" >
    <form>
      <!-- Form elemets--> 
    </form>
    <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'"  [text]="'Next'" [size]="'large'" (click)="onSubmit()"></lib-button>
</lib-modal-layout>